import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {valueFormatter} from 'utils/utils'

const Base = styled.span`
    margin: 0 10px;
    text-overflow: ellipsis;
    height: 100%;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    opacity: ${props => props.lookup ? '0.5' : '1'};
`

const Formula = ({defaultValue, name}) => {
    const value = valueFormatter(defaultValue, name)

    return (
        <Base>
            {value}
        </Base>
    )
}

export default injectIntl(Formula)
